import { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { getSignupTermsAndConditions } from 'utils/signup'

/**
 * Holds the signup consent checkbox state, seeded from the tenant config
 * (`signupTermsAndConditions`) so a tenant can opt its users out of pre-checked
 * newsletter/sms consents. The state is re-seeded when the tenant config lands,
 * since it is fetched after the form can already be mounted.
 */
const useSignupTermsAndConditions = () => {
  const signupTermsAndConditions = useSelector(
    (state) => state.uiConfig?.general?.signupTermsAndConditions
  )

  const defaultConditions = useMemo(
    () => getSignupTermsAndConditions(signupTermsAndConditions),
    [signupTermsAndConditions]
  )

  const [acceptConditions, setAcceptConditions] = useState(defaultConditions)

  useEffect(() => {
    setAcceptConditions(defaultConditions)
  }, [defaultConditions])

  return { defaultConditions, acceptConditions, setAcceptConditions }
}

export default useSignupTermsAndConditions
